import { chooseRandomComponentValue } from "./chooseRandomComponentValue";
import { filterComponentValues } from "./filterComponentValues";
import type { ComponentStoreData } from "./types";

/**
 * Chooses random component values from the component store data
 * @param componentStoreData - The component store data to choose random component values from
 * @returns A record of component names and their random component values
 */
export const chooseRandomComponents = (componentStoreData: ComponentStoreData): Record<string, string> => {
  if (!componentStoreData?.components) {
    return {};
  }
  const deactivatedValues = componentStoreData.deactivatedValues ?? {};
  return Object.fromEntries(
    Object.entries(componentStoreData.components).map(([name, values]) => {
      const deactivatedForComponent = new Set(deactivatedValues[name] ?? []);
      const filteredValues = filterComponentValues(values).filter((value) => !deactivatedForComponent.has(value));
      return [name, chooseRandomComponentValue(filteredValues)];
    })
  ) as Record<string, string>;
};
